(function () {
  if (window.__dlDiscountCode) return;
  window.__dlDiscountCode = true;

  function cartRoot() {
    var routes = window.Shopify && Shopify.routes && Shopify.routes.root;
    return routes || '/';
  }

  function setMsg(root, state, text) {
    var msg = root && root.querySelector('[data-dl-discount-msg]');
    if (!msg) return;
    msg.hidden = !text;
    msg.dataset.state = state || '';
    msg.textContent = text || '';
    // The phone drawer pins Check out over the bottom of the list (dl-drawer-menu-fixes.css); keep the message above it.
    var drawer = text && msg.closest && msg.closest('#CartDrawer');
    if (drawer && msg.scrollIntoView) whenBuilt(drawer, function () { if (msg.isConnected && !msg.hidden) msg.scrollIntoView({ block: 'nearest' }); });
  }

  // Right after refresh() swaps the drawer HTML, Alpine still has parts under x-cloak, so the drawer is too short to
  // scroll and scrollIntoView does nothing. Wait until nothing is cloaked (about half a second at most).
  function whenBuilt(drawer, done) {
    var raf = window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function (f) { return setTimeout(f, 16); };
    var frames = 0;
    (function tick() {
      if (!drawer.querySelector('[x-cloak]') || ++frames > 30) return raf(done);
      raf(tick);
    })();
  }

  function placeOf(root) {
    return {
      inDrawer: !!(root.closest && root.closest('#CartDrawer')),
      inFooter: !!(root.closest && root.closest('#main-cart-footer')),
      inItems: !!(root.closest && root.closest('#main-cart-items'))
    };
  }

  function findRoot(place) {
    var scope = document;
    if (place.inDrawer) scope = document.querySelector('#CartDrawer') || document;
    else if (place.inFooter) scope = document.querySelector('#main-cart-footer') || document;
    else if (place.inItems) scope = document.querySelector('#main-cart-items') || document;
    return scope.querySelector('[data-dl-discount]');
  }

  function matchingCode(cart, code) {
    var wanted = code.toLowerCase();
    var codes = cart.discount_codes || [];
    for (var i = 0; i < codes.length; i++) {
      if ((codes[i].code || '').toLowerCase() === wanted) return codes[i];
    }
    return null;
  }

  // /cart/update.js replaces every code on the cart, so read the codes that already work first.
  async function workingCodes() {
    try {
      var res = await fetch(cartRoot() + 'cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' });
      var cart = await res.json();
      return (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
    } catch (e) {
      return [];
    }
  }

  async function updateDiscount(code) {
    var res = await fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    });
    var data = {};
    try { data = await res.json(); } catch (e) { data = {}; }
    data.ok = res.ok;
    return data;
  }

  async function refresh(place) {
    if (place.inFooter || place.inItems || /\/cart\/?$/.test(location.pathname)) {
      var page = await fetch(location.pathname, { credentials: 'same-origin' }).then(function (r) { return r.text(); });
      var doc = new DOMParser().parseFromString(page, 'text/html');
      ['main-cart-footer', 'main-cart-items'].forEach(function (id) {
        var fresh = doc.getElementById(id);
        var live = document.getElementById(id);
        if (fresh && live) live.innerHTML = fresh.innerHTML;
      });
      return;
    }
    var section = await fetch(location.pathname + '?section_id=cart-drawer', { credentials: 'same-origin' }).then(function (r) { return r.text(); });
    var drawerDoc = new DOMParser().parseFromString(section, 'text/html');
    var freshDrawer = drawerDoc.querySelector('#CartDrawer');
    var liveDrawer = document.querySelector('#CartDrawer');
    if (freshDrawer && liveDrawer) liveDrawer.innerHTML = freshDrawer.innerHTML;
  }

  async function apply(root) {
    if (!root || root.dataset.busy === '1') return;
    var input = root.querySelector('[data-dl-discount-input]');
    var button = root.querySelector('[data-dl-discount-apply]');
    var code = (input.value || '').trim();
    if (!code) {
      setMsg(root, 'err', 'Enter a discount code.');
      input.focus();
      return;
    }
    var place = placeOf(root);
    root.dataset.busy = '1';
    if (button) button.disabled = true;
    setMsg(root, '', 'Checking…');
    try {
      var existing = (await workingCodes()).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
      var cart = await updateDiscount(existing.concat(code).join(','));
      var match = matchingCode(cart, code);
      if (!cart.ok || !match || !match.applicable) {
        await updateDiscount(existing.join(','));
        await refresh(place);
        var failed = findRoot(place) || root;
        var failedInput = failed.querySelector('[data-dl-discount-input]');
        if (failedInput) failedInput.value = code;
        setMsg(failed, 'err', existing.length ? "That code can't be used with this cart or with your current code." : "That code isn't valid for this cart.");
        return;
      }
      await refresh(place);
      var next = findRoot(place) || root;
      var nextInput = next.querySelector('[data-dl-discount-input]');
      if (nextInput) nextInput.value = code;
      setMsg(next, 'ok', 'Discount applied.');
    } catch (err) {
      setMsg(root, 'err', "That code isn't valid for this cart.");
    } finally {
      var live = findRoot(place) || root;
      if (live) delete live.dataset.busy;
      var liveButton = live && live.querySelector('[data-dl-discount-apply]');
      if (liveButton) liveButton.disabled = false;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-dl-discount-apply]');
    if (!button) return;
    event.preventDefault();
    apply(button.closest('[data-dl-discount]'));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var input = event.target.closest && event.target.closest('[data-dl-discount-input]');
    if (!input) return;
    event.preventDefault();
    apply(input.closest('[data-dl-discount]'));
  });
})();
